import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import useAuthentication from '../auth/authHelper';

const ProtectedRoutes = () => {
  const { isAuthenticated } = useAuthentication();
  if (!isAuthenticated()) {
    return <Navigate to="/user/login" />;
  }
  return <Outlet />;
}

export default ProtectedRoutes